import Hero from "../components/Hero";
import FeaturedDishes from "../components/FeaturedDishes";

const Home = () => {
  return (
    <div>
      <Hero />
      <FeaturedDishes />
    </div>
  );
};

export default Home;
